import { RawDraftContentState } from 'draft-js';

import { ApplicationState } from '../../../../store/types';
import { NotificationTemplate } from './types';
import { getNotificationsRoot } from '../../store/selectors';

export const getNotificationTitle = (state: ApplicationState): string => getNotificationsRoot(state).title;

export const getNotificationContent = (state: ApplicationState): RawDraftContentState | null => getNotificationsRoot(state).content;

export const getNotificationClientIds = (state: ApplicationState): number[] => getNotificationsRoot(state).clientIds;

export const getNotificationAdminOnly = (state: ApplicationState): boolean => getNotificationsRoot(state).adminOnly;

export const getIsSending = (state: ApplicationState): boolean => getNotificationsRoot(state).isSending;

export const getSendingError = (state: ApplicationState): string | null => getNotificationsRoot(state).sendError;

export const getNotificationToSend = (state: ApplicationState): NotificationTemplate => ({
    title: getNotificationTitle(state),
    content: getNotificationContent(state),
    clientIds: getNotificationClientIds(state),
    adminOnly: getNotificationAdminOnly(state)
});

export const getPreviewModalOpen = (state: ApplicationState): boolean => getNotificationsRoot(state).previewOpen;
